/**
 * Glowwa Science Behind the Glow — product tab switcher.
 * Figma: "The Science Behind the Glow" mobile + desktop frames.
 */

(function () {
  'use strict';

  const ROOT = '[data-glowwa-science]';

  /**
   * Activate a tab by its index (1-based, matching data-glowwa-science-tab).
   *
   * @param {HTMLElement} root
   * @param {string} tabIndex
   */
  function activateTab(root, tabIndex) {
    const tabs = root.querySelectorAll('.glowwa-science__pill');
    const panels = root.querySelectorAll('[data-glowwa-science-panel]');

    tabs.forEach((tab) => {
      const isActive = tab.dataset.glowwaScienceTab === tabIndex;
      tab.classList.toggle('is-active', isActive);
      tab.setAttribute('aria-selected', isActive ? 'true' : 'false');
      tab.tabIndex = isActive ? 0 : -1;
    });

    panels.forEach((panel) => {
      const panelId = panel.id;
      // Panel id ends with `-panel-{index}`; find matching tab whose aria-controls = panelId
      const matchingTab = root.querySelector(
        `.glowwa-science__pill[aria-controls="${panelId}"]`,
      );
      const isActive =
        matchingTab != null &&
        matchingTab.dataset.glowwaScienceTab === tabIndex;

      panel.classList.toggle('is-active', isActive);
      panel.hidden = !isActive;
    });
  }

  /**
   * @param {HTMLElement} root
   */
  function wireRoot(root) {
    if (root.dataset.glowwaScienceInit === 'true') {
      return;
    }
    root.dataset.glowwaScienceInit = 'true';

    root.querySelectorAll('.glowwa-science__pill').forEach((tab) => {
      tab.addEventListener('click', () => {
        const tabIndex = tab.dataset.glowwaScienceTab;
        if (!tabIndex) {
          return;
        }
        activateTab(root, tabIndex);
      });

      // Arrow key navigation within tablist
      tab.addEventListener('keydown', (event) => {
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
          return;
        }
        const tabs = [
          ...root.querySelectorAll('.glowwa-science__pill'),
        ];
        const index = tabs.indexOf(tab);
        if (index < 0) {
          return;
        }
        event.preventDefault();
        const delta = event.key === 'ArrowRight' ? 1 : -1;
        const next = tabs[index + delta];
        if (next) {
          next.focus();
          next.click();
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll(ROOT).forEach(wireRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  // Re-wire after Shopify editor section reload
  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target?.querySelector?.(ROOT);
    if (root instanceof HTMLElement) {
      delete root.dataset.glowwaScienceInit;
      wireRoot(root);
    }
  });

  // Switch to the selected block's tab in the editor
  document.addEventListener('shopify:block:select', (event) => {
    const blockId = event.detail?.blockId;
    if (!blockId) return;
    const pill = document.querySelector(
      `.glowwa-science__pill[data-block-id="${blockId}"]`,
    );
    if (!pill) return;
    const root = pill.closest(ROOT);
    if (!root) return;
    activateTab(root, pill.dataset.glowwaScienceTab);
  });
})();
